"use strict"

var $ = jQuery;

$(document).ready(function () {

    var expandButtons = $('.expand-group .expand-button');

    function toogleExpand(e)
    {
        e.preventDefault();

        var that = $(this);
        that.closest('.expand-group').toggleClass('expanded');

        addTextForButton(that);
    }

    function addTextForButton(expandButton)
    {
        expandButton.find('span').remove();

        if (expandButton.closest('.expand-group').is('.expanded')) {
            expandButton.append('<span>'+ expandButton.data('close-text') +'</span>');
        } else {
            expandButton.append('<span>'+ expandButton.data('expand-text') +'</span>');
        }
    }

    expandButtons.each(function () {
        var that = $(this);

        addTextForButton(that);
    });

    expandButtons.on('click', toogleExpand);

    addScript(scripts, 'matchheight', () => {
        let options = {
            byRow: true,
            property: 'height',
            target: null,
            remove: false
        };
        $('.section-recommend-option .carousel-recommend-option .owl-item h6.block-transit-0up-600').matchHeight(options);
        $('.section-recommend-option .carousel-recommend-option .owl-item h3.block-transit-0up-600').matchHeight(options);
    });

});